import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { user } from './modules/user'
import { shop } from './modules/shop'
import { basket } from './modules/basket'

import { notifications } from './modules/notifications'

import { vouchers } from './modules/vouchers'
import { shared } from './modules/shared'

//encryption in Local Storage
// https://github.com/softvar/secure-ls
import SecureLS from 'secure-ls'
var ls = new SecureLS({ isCompression: false })

const store = createStore({
	modules: {
		user,
		shared,
		notifications,
		shop,
		basket,
		vouchers,
	},
	plugins: [
		createPersistedState({
			key: 'pact-data',
			/*rehydrated: function(store){
        console.log('water + fire',store)
      },*/
			storage: {
				getItem: (key) => ls.get(key),
				setItem: (key, value) => ls.set(key, value),
				removeItem: (key) => ls.remove(key),
			},
		}),
	],
})
/*
function haha(mutation,state){
  console.log('x')
  console.log(mutation,state)
}
store.subscribe(haha)
DEBUG */

// One-time purge of stale persisted shop products (slug reuse across PDP types
// left old product shapes in pact-data, crashing PDPs on first render).
// Bump the version (or set PURGE_SHOP_PRODUCTS_VERSION in .env + rebuild) to purge again.
const PURGE_VERSION = '2026-10-09-flexi-slug-repoint'
const PURGE_FLAG_KEY = 'pact-products-purged'

if (localStorage.getItem(PURGE_FLAG_KEY) !== PURGE_VERSION) {
	// clears state.products + state.timeOfLastCache -> PDP refetches fresh from BE
	// -> persistedstate plugin immediately rewrites cleaned state into pact-data
	store.commit('shop/resetInfo')
	localStorage.setItem(PURGE_FLAG_KEY, PURGE_VERSION)
}

export default store
